import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack } from "react-icons/io";
import "../../../pages/style.css";
import "../../../pages/responsive.css";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router";
import { showAlert } from "../../../utils/Helpers";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  getLocalStorageItem,
  handleEncrypt,
  validateEmail,
  getNameValidationMessage,
  validatePhoneNumber,
  getLanguage
} from "../../../utils/HelperFunctions";

import { useTheme } from "../../../components/ThemeSwitcher/ThemeSwitcher";
import DivLoader from "../Loader/DivLoader";
import { encryptUserId, decryptUserId } from "../../../utils/cryptoUtils";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import useReCaptcha from "../../../utils/ReCaptcha";
import { useSearchParams, useLocation } from "react-router-dom";
import { useEDPContext, useHeaderProfileContext } from "../../EDPContext";

const SignInModal = ({ handleClose, setShowResetConfirmation }) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const { getReCaptchaToken } = useReCaptcha();
  const { instance } = useMsal();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(FaEyeSlash);
  const [activeTab, setActiveTab] = useState("internalUserAD");

  const [ForgotEmail, setForgotEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [showSignIn, setShowSignIn] = useState(true);
  const [rememberMe, setRememberMe] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [oldPasswordType, setOldPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [Requestmsg, setRequestmsg] = useState(null);
  const [emailError, setemailError] = useState("");
  const [unameError, setUnameError] = useState("");
  const [loader, setloader] = useState("");
  const location = useLocation();

  const { isWebView, setIsWebView } = useEDPContext();
  const [registerMsg, setRegisterMsg] = useState(false);

  const [formData, setFormData] = useState({
    // password: "",
    firstName: "",
    lastName: "",
    email: "",
    jobTitle: "",
    organization: "",
    address: "",
    city: "",
    state: "",
    phone: "",
    postalCode: "",
    //username: "",
    signupusername: "",
    signuppassword: ""
  });
  const [isCtrlFocused, setIsCtrlFocused] = useState({
    signupusername: false,
    signuppassword: false,
    firstName: false,
    lastName: false,
    email: false,
    jobTitle: false,
    organization: false,
  });

  const [isCtrlEmpty, setIsCtrlEmpty] = useState({
    signupusername: true,
    signuppassword: true,
    firstName: true,
    lastName: true,
    email: true,
    jobTitle: true,
    organization: true,
  });


  //const usernameRegex = /^[a-zA-Z0-9_]{3,20}$/; // 3-20 chars, alphanumeric, underscores
  const usernameRegex = /^[a-zA-Z0-9 _\-\.]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
  // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/; // 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special
  const passwordRegex = /^(?=.*[@$!%*?&]).{8,}$/;//8 chars, 1 special
  useEffect(() => {
    if (localStorage.getItem("webView") === "true") {
      setIsWebView(true)
    }
    else {
      setIsWebView(false)
    }
  }, [])
  useEffect(() => {
    let Email = getLocalStorageItem("UserEmail");
    let Username = getLocalStorageItem("Username");
    let pswrd = getLocalStorageItem("PASSWORD");
    if (Username || Email && pswrd) {
      // setEmail(Email);
      setUsername(Username);
      setPassword(pswrd);
      setIsCtrlEmpty({
        signupusername: true,
        signuppassword: true,
        firstName: true,
        lastName: true,
        email: true,
        jobTitle: true,
        organization: true,
      });
    }
  }, []);
  const handleLogin = async () => {
    const _loginRequest = window.loginRequest;
    await instance.loginRedirect(_loginRequest);
  };
  const validate = () => {
    const newErrors = {};

    // Validate username: check if it's empty
    if (!username || username.trim().length === 0) {
      newErrors.username = `${t("requiredField")}`;
    } else {
      // Check if it's a valid email or username
      if (emailRegex.test(username)) {
        // If it's an email, validate with the email regex
        if (!emailRegex.test(username)) {
          newErrors.username = `${t("invalidEmail")}`;
        }
      } else if (!usernameRegex.test(username)) {
        // If it's not a valid username, then it's an invalid input
        newErrors.username = `${t("invalidUsername")}`;
      }
    }

    // Validate password: check if it's empty
    if (!password || password.trim().length === 0) {
      newErrors.password = `${t("requiredField")}`;
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors(prev => ({ ...prev, username: '', password: '' }));
    }
    // return newErrors;
    return Object.keys(newErrors).length === 0 ? true : false;
  };


  const handleExtnalUser = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setLoading(false);
      return;
    }
    localStorage.setItem("UEmail", email);
    if (rememberMe) {
      localStorage.setItem("UserEmail", email);
      localStorage.setItem("Username", username);
      localStorage.setItem("PASSWORD", password);
    } else {
      localStorage.removeItem("UserEmail");
      localStorage.removeItem("Username");
      localStorage.removeItem("PASSWORD", password);
    }

    // const CaptechaToken = await getReCaptchaToken("signin");
    // if (!CaptechaToken) {
    //   alert("reCAPTCHA validation failed. Please try again.");
    //   return;
    // }

    const apiUrl = `${process.env.REACT_APP_API_URL}/auth/db-loginforweb`;

    const isEmail = (input) => /\S+@\S+\.\S+/.test(input);

    const encryptedUserName = encryptUserId(username);
    const encryptedPassword = encryptUserId(password)

    // const requestBody = {
    //   [isEmail(username) ? "email" : "username"]: encryptedUserName,
    //   // password: await handleEncrypt(password),
    //   password: encryptedPassword,
    //   captchatoken: CaptechaToken
    // };

    const requestBody = {
      [isEmail(username) ? "email" : "username"]: encryptedUserName,
      password: encryptedPassword,
    };

    await sendApiRequest(apiUrl, requestBody);
  };

  const sendApiRequest = async (url, body) => {
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.message);
        setTimeout(() => setErrorMessage(""), 3000);
        return;
      }

      if (typeof data !== "undefined") {
        if(data.isInternalUser === 0 && data.status === 1){
          showAlert(t("SignInvalidUser"), "error");
          setTimeout(() => setErrorMessage(""), 3000);
          return;
        }
        if (data.status && (data.status === 1 || data.status === 3)) {
          showAlert(t("insufficientPermission"), "error");
          setErrorMessage(t("insufficientPermission"), "error");
          setTimeout(() => setErrorMessage(""), 3000);
          return;
        }
      }

      if (!isWebView) {
        let decryptEmail = "";
        if (data.email != undefined) {
          decryptEmail = decryptUserId(data.email);
          data.email = decryptEmail;
        }
        const decryptUserName = decryptUserId(data.username);
        data.username = decryptUserName;

        const decryptUserGroups = data.groups?.map(encryptedGroup => decryptUserId(encryptedGroup));
        data.groups = decryptUserGroups;
      }




      const { username, jwtToken, role, userId, groups, isInternalUser } = data;
      if (jwtToken !== "") {
        localStorage.setItem("token", jwtToken.token);
        localStorage.setItem("TokenExpTime", jwtToken.tokenExpirationTime);
        localStorage.setItem("username", username);
        localStorage.setItem("role", role);
        localStorage.setItem("UserId", userId);
        //localStorage.setItem("groups", JSON.stringify(groups));
        localStorage.setItem("isInternalUser", isInternalUser);
        if (data.email) localStorage.setItem("Email", data.email);
        handleClose();
        setShowSignIn(false);
        navigate(0)

        // setTimeout(() => {
        //   navigate(0)
        // }, 100);

        //Login and logout sync across all the tabs
        //Starts here  
        //sessionStorage.setItem("tabRefreshed", "true");
        //Ends here

        // window.location.href = `${process.env.REACT_APP_BASE_URL}`; // Navigate to homepage
      } else {
        showAlert(t("UnauthorizedLogin"), "error");
      }
    } catch (error) {
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        setErrorMessage(t("networkError"));
        setTimeout(() => setErrorMessage(""), 3000);
      } else {
        setErrorMessage(error.message);
        setTimeout(() => setErrorMessage(""), 3000);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = () => {
    if (type === "password") {
      setIcon(FaEye);
      setType("text");
    } else {
      setIcon(FaEyeSlash);
      setType("password");
    }
  };

  const handleOldPasswordToggle = () => {
    setOldPasswordType(oldPasswordType === "password" ? "text" : "password");
  };

  const handleNewPasswordToggle = () => {
    setNewPasswordType(newPasswordType === "password" ? "text" : "password");
  };

  const handleConfirmPasswordToggle = () => {
    setConfirmPasswordType(
      confirmPasswordType === "password" ? "text" : "password"
    );
  };

  const handleForgotPasswordClick = () => {
    setShowForgotPassword(true);
  };

  const handleBackToSignInClick = () => {
    setShowForgotPassword(false);
    setShowSignUp(false);
    setShowNewPassword(false);
    setActiveTab("internalUserAD");
    setemailError("");
    setUnameError("");
    setErrors("");
  };

  const handleSignUpClick = () => {
    setEmail("");
    setUsername("");
    setPassword("");
    setShowSignUp(true);
    setErrors("");
    setErrorMessage("");
  };

  const handlesigninClick = () => {
    setErrors("");
    setemailError("");
    setUnameError("");
    setErrorMessage("");
    setShowSignIn(true);
    setShowSignUp(false);
    setRequestmsg("");
    setRegisterMsg(false);
    setFormData("");
    setIsCtrlEmpty({
      signupusername: true,
      signuppassword: true,
      firstName: true,
      lastName: true,
      email: true,
      jobTitle: true,
      organization: true,
    });
  };

  //forgotpassword
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    const emailVal = validateEmail(t, ForgotEmail);
    if (emailVal !== "") {
      setemailError(emailVal);
      return;
    }
    try {
      setloader(true);
      const encryptedEmail = encryptUserId(ForgotEmail);
      const response = await fetch(
        //`${process.env.REACT_APP_API_URL}/Auth/forgot-password`,
        `${process.env.REACT_APP_API_URL}/Auth/forgot-passwordforweb`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Email: encryptedEmail }),
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          navigate("/401");
        }

        const errorText = await response.json();
        throw new Error(`${errorText.message}`);
      }
      const data = await response.json();

      setloader(false);
      handleClose(true);
      setShowResetConfirmation(true);
    } catch (error) {
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        showAlert(t("networkError"), "error");
        setErrorMessage(t("networkError"));
        setTimeout(() => setErrorMessage(""), 3000);
        setloader(false);
      } else {
        showAlert(error.message, "error");
        setErrorMessage(error.message);
        setTimeout(() => setErrorMessage(""), 3000);
        setloader(false);
      }
    }

  };

  const handleChangePasswordClick = () => {
    setShowNewPassword(true);
  };
  const handleSaveSuccessfulSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (email.length === 0) {
      validationErrors.email = t("requiredField");
    }
    if (oldPassword.length === 0) {
      validationErrors.oldPassword = t("requiredField");
    }
    if (newPassword.length === 0) {
      validationErrors.newPassword = t("requiredField");
    }
    if (confirmPassword.length === 0) {
      validationErrors.confirmPassword = t("requiredField");
    }
    if (Object.keys(validationErrors).length === 0) {
      if (newPassword.length < 6) {
        validationErrors.newPassword = t("passwordTooShort");
      }
      if (newPassword !== confirmPassword) {
        validationErrors.confirmPassword = t("passwordsDoNotMatch");
      }
      validationErrors.emailId = validateEmail(t, email);
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    //const NewPassword = await handleEncrypt(newPassword);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Auth/change-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": getLanguage(),
          },
          body: JSON.stringify({ email, oldPassword, newPassword }),
        }
      );

      if (!response.ok) {
        let data = await response.json();
        showAlert(data.message, "error");
        setErrorMessage(data.message);
        setTimeout(() => setErrorMessage(""), 3000);
        return;
      }
      await response.json();
      setShowSaveConfirmation(true);
      setShowSignIn(true);
      setShowForgotPassword(false);
      setShowSignUp(false);
    } catch (error) {
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        showAlert(t("networkError"), "error");
        setErrorMessage(t("networkError"));
        setTimeout(() => setErrorMessage(""), 3000);
      } else {
        showAlert(error.message, "error");
        setErrorMessage(t("networkError"));
        setTimeout(() => setErrorMessage(""), 3000);
      }
    }
  };

  const handleCloseSaveConfirmation = () => setShowSaveConfirmation(false);

  const signupvalidate = () => {
    const newErrors = {};
    const emailVal = validateEmail(t, formData.email);
    if (emailVal !== "") {
      newErrors.email = emailVal;
    }

    const nameVal = getNameValidationMessage(
      t,
      formData.signupusername,
      t("invalidNameValidation")
    );
    const regex = /^[a-zA-Z0-9 _\-\.]+$/;
    if (!regex.test(formData.signupusername)) {
      newErrors.signupusername = t("invalidNameValidation");
      // throw new Error('Username can only contain letters, numbers, underscores (_), and hyphens (-).');
    }
    if (formData.signupusername.includes('http') || formData.signupusername.includes('www') || formData.signupusername.includes('.com')) {
      newErrors.signupusername = t("invalidNameValidation");
      // throw new Error('Username cannot contain URLs.');
    }
    // if (!formData.signupusername) {
    //   newErrors.signupusername = t("requiredField");
    // }
    // else if(!(/^(?=.{3,30}$)([A-Za-z0-9][._]?)*$/.test(formData.signupusername))){
    //   newErrors.signupusername = t("invalidNameValidation");
    // }
    if (nameVal !== "") newErrors.signupusername = nameVal;
    // Password validation
    if (!formData.signuppassword) {
      newErrors.signuppassword = `${t("requiredField")}`;
    }

    if (formData.signuppassword && !/(?=.*[!@#$%^&*(),.?":{}|<>])(?=.{8,})/.test(formData.signuppassword)) {
      newErrors.signuppassword = newErrors.signuppassword
        ? newErrors.signuppassword + ' ' + t("passwordValidation2")
        : t("passwordValidation2");
    }

    const firstNameValidation = getNameValidationMessage(
      t,
      formData.firstName,
      t("invalidNameValidation")
    );
    if (firstNameValidation) {
      newErrors.firstName = firstNameValidation;
    }
    const lastNameValidation = getNameValidationMessage(
      t,
      formData.lastName,
      t("invalidNameValidation")
    );
    if (lastNameValidation) {
      newErrors.lastName = lastNameValidation;
    }
    const jobTitleValidation = getNameValidationMessage(
      t,
      formData.jobTitle,
      t("invalidNameValidation")
    );
    if (jobTitleValidation) {
      newErrors.jobTitle = jobTitleValidation;
    }
    const organizationValidation = getNameValidationMessage(
      t,
      formData.organization,
      t("invalidNameValidation")
    );
    if (organizationValidation) {
      newErrors.organization = organizationValidation;
    }
    // const cityValidation = getNameValidationMessage(
    //   t,
    //   formData.city,
    //   t("invalidNameValidation"),
    //   false
    // );
    // if (cityValidation) {
    //   newErrors.city = cityValidation;
    // }
    // const stateValidation = getNameValidationMessage(
    //   t,
    //   formData.state,
    //   t("invalidNameValidation"),
    //   false
    // );
    // if (stateValidation) {
    //   newErrors.state = stateValidation;
    // }

    // if (/[^0-9]/.test(formData.postalCode)) {
    //   newErrors.postalCode = `${t("Invalid input. Only numbers are allowed")}`;
    // }
    // const phoneValidation = validatePhoneNumber(t, formData.phone, false);
    // if (phoneValidation) {
    //   newErrors.phone = phoneValidation;
    // }

    // Setting errors and returning validity
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleChange = (evt) => {
    const { name, value } = evt.target;

    if (name === "postalCode" || name === "phone") {
      // Update state only if the value contains digits (numeric values)
      if (/^\d*$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      // For other fields, update the state normally
      setFormData({ ...formData, [name]: value });
    }
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    switch (name) {
      case "email":
        errorMessage = validateEmail(t, value);
        break;
      case "username":
      case "firstName":
      case "lastName":
      case "jobTitle":
      case "organization":
      case "signupusername":
        // case "city":
        // case "state":
        errorMessage = getNameValidationMessage(t, value, t("invalidNameValidation"));
        break;
        // case "postalCode":
        //   if (/[^0-9]/.test(value)) {
        //     errorMessage = t("Invalid input. Only numbers are allowed");
        //   }
        //   break;
        // case "phone":
        //   errorMessage = validatePhoneNumber(t, value, false);
        //   break;
        // case "password":
        //   case "signuppassword":
        //   if (!value) {
        //     errorMessage = t("requiredField");
        //   }
        //   else if (value < 8) {
        //     errorMessage = t("passwordTooShort");
        //   }
        //   else if (!/(?=.*[!@#$%^&*(),.?":{}|<>])(?=.{8,})/.test(value)) {
        //     errorMessage = t("passwordValidation2");
        //   }
        // else if (!/(?=.*[!@#$%^&*(),.?":{}|<>])(?=.{8,})/.test(value)) {
        //   errorMessage = t("passwordValidation2");
        //}
        break;
      default:
        errorMessage = "";
    }
    setErrors((prevErrors) => {
      if (errorMessage) {
        return { ...prevErrors, [name]: errorMessage };
      } else {
        const { [name]: removed, ...rest } = prevErrors; // Remove error if valid
        return rest;
      }
    });
  };

  const handleFocus = (e) => {
    const name = e.target.name;
    setIsCtrlFocused((prevState) => ({
      ...prevState,
      [name]: true, // Set focus to true for the current input
    }));
  };

  // Handle blur
  const handleBlur = (e) => {
    const name = e.target.name;
    setIsCtrlFocused((prevState) => ({
      ...prevState,
      [name]: false, // Set focus to false when input loses focus
    }));
    setIsCtrlEmpty((prevState) => ({
      ...prevState,
      [name]: e.target.value.trim() === "", // Check if the input is empty after blur
    }));
  };


  const resetInputs = () => {
    setFormData("");
    setErrors("");
    setIsCtrlEmpty({
      username: true,
      password: true,
      firstName: true,
      lastName: true,
      email: true,
      jobTitle: true,
      organization: true,
    });
    setErrorMessage("");
  }

  //submit for signupform
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!signupvalidate()) return;
    setloader(true);
    try {
      // Encrypt the password
      setloader(true);
      //const encryptedPassword = await handleEncrypt(formData.password);

      const encryptedUserName = encryptUserId(formData.signupusername);
      const encryptedPassword = encryptUserId(formData.signuppassword);
      const encryptedEmail = encryptUserId(formData.email);
      const encryptedPhoneNumber = encryptUserId(formData.phone);

      const signupObj = {
        UserName: encryptedUserName,
        FirstName: formData.firstName,
        LastName: formData.lastName,
        Password: encryptedPassword,
        Email: encryptedEmail,
        JobTitle: formData.jobTitle,
        Phone: encryptedPhoneNumber,
        Organization: formData.organization,
        Address: formData.address,
        City: formData.city,
        State: formData.state,
        PostalCode: formData.postalCode
      };

      // Create a new object with the encrypted password
      //const dataToSubmit = { ...formData, password: formData.password };

      // Make the POST request with the correct headers and JSON stringified body
      const response = await fetch(
        //`${process.env.REACT_APP_API_URL}/User/registerUser`,
        `${process.env.REACT_APP_API_URL}/User/registerUserforWeb`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(signupObj),
        }
      );

      if (!response.ok) {
        const errorText = await response.json();
        setErrorMessage(errorText.message);
        setRequestmsg("");
        setRegisterMsg(false);
        return;

      }
      await response.json();
      setShowForgotPassword(false);
      setShowNewPassword(false);
      //showAlert(t("RegisterUsermsg"));
      setRegisterMsg(true);
      //setRequestmsg(t("waitingForApproval"));
      resetInputs();
      setloader(false);
    } catch (error) {
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        showAlert(t("networkError"), "error");
        setErrorMessage(t("networkError"));
        setTimeout(() => setErrorMessage(""), 3000);
      } else {
        showAlert(error.message, "error");
        setErrorMessage(error.message);
        setTimeout(() => setErrorMessage(""), 3000);
      }
      console.error("Error creating user:", error);
    } finally {
      setloader(false);
    }
  };



  return (
    showSignIn && (
      <section className="signup-modal h-100">
        <div className="container h-100 p-0">
          <div className="h-100">
            <div className=" g-0 h-100 signGrid">
              <div className="col-12 col-md-12 col-lg-12 h-100 Signin-side">
                <div
                  className="col-12 col-xl-11 pt-0 LoginImgDiv"
                  style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/Rectangle-signin.png)`,
                  }}
                >

                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-12 position-relative">
                <div className="card-body py-4 pt-2 sm-full-pd">
                  <div
                    className={`col-sm-12 col-md-12 offset-md-0 ${showSignUp ? "w-100-signup" : ""
                      }`}
                  >
                    <div className="row">
                      <div className="col-12 modal-logo">
                        <img
                          alt=""
                          className="img-fluid mb-3"
                          src={
                            theme === "dark"
                              ? `${process.env.PUBLIC_URL}/images/sign-whitelogo.svg`
                              : `${process.env.PUBLIC_URL}/images/newLogo.svg`
                          }
                        />
                      </div>
                      {!showForgotPassword &&
                        !showSignUp &&
                        !showNewPassword ? (
                        // <GoogleReCaptchaProvider reCaptchaKey={Site_key}>
                        <div className="col-12">
                          <div className="mb-3">
                            <h3 className="title-text mb-0">
                              {t("welcomeBack")}
                            </h3>
                            <p className="subtitle-text">{t("pleaseSignIn")}</p>
                          </div>
                          <div className="mb-2">
                            <div className="signup-form-container">
                              <form
                                action="#!"
                                className="signup-form"
                                onSubmit={handleExtnalUser}
                              >
                                <div className="row gy-3 gy-md-4 overflow-hidden ">
                                  {/* <div className="col-12 mb-2 ">
                                    <input
                                      type="text"
                                      name="email"
                                      id="email"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      className={`form-control ${
                                        errors.email ? "input-error" : ""
                                      }`}
                                      placeholder="Enter Email"
                                    />
                                    {errors.email && (
                                      <span className="error">
                                        {errors.email}
                                      </span>
                                    )}
                                  </div> */}
                                  <div className="col-12 mb-2 ">
                                    <input
                                      type="text"
                                      name="username"
                                      id="username"
                                      value={username}
                                      onChange={(e) => setUsername(e.target.value)}
                                      className={`form-control ${errors.username ? "input-error" : ""
                                        }`}
                                      placeholder={t("EnterUsername")}
                                    />
                                    {errors.username && (
                                      <span className="error">
                                        {errors.username}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-12 mt-0 position-relative">
                                    <input
                                      type={type}
                                      name="password"
                                      id="password"
                                      value={password}
                                      onChange={(e) =>
                                        setPassword(e.target.value)
                                      }
                                      className={`form-control ${errors.password ? "input-error" : ""
                                        }`}
                                      placeholder="Enter Password"
                                    />
                                    {errors.password && (
                                      <span className="error">
                                        {errors.password}
                                      </span>
                                    )}
                                    <label
                                      className="eye-icon-position"
                                      onClick={handleToggle}
                                    >
                                      {type === "text" ? (
                                        <FaEyeSlash size={22} />
                                      ) : (
                                        <FaEye size={22} />
                                      )}
                                    </label>
                                  </div>
                                  <div className="col-12 d-flex justify-content-between align-items-center">
                                    <div className="form-check d-flex jusytify-content-start align-items-center m-0">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        name="remember_me"
                                        id="remember_me"
                                        onChange={() =>
                                          setRememberMe(!rememberMe)
                                        }
                                      />
                                      <label
                                        className="form-check-label text-secondary"
                                        htmlFor="remember_me"
                                      >
                                        {t("rememberMe")}
                                      </label>
                                    </div>
                                    <button
                                      type="button"
                                      className="link-secondary-forgot text-decoration-none nobuttonStyle"
                                      onClick={handleForgotPasswordClick}
                                    >
                                      {t("forgotPassword1")}
                                    </button>
                                  </div>
                                  {errorMessage && (
                                    <div
                                      className="error-message"
                                      style={{ color: "red" }}
                                    >
                                      {errorMessage}
                                    </div>
                                  )}
                                  <div className="col-12">
                                    <div className="d-grid">
                                      <button
                                        className="btn bsb-btn-xl btn-primary lg-signin-btn"
                                        type="submit"
                                        disabled={loading}
                                      >
                                        {loading ? (
                                          <>
                                            <Spinner
                                              as="span"
                                              animation="border"
                                              size="sm"
                                              role="status"
                                              aria-hidden="true"
                                            />

                                          </>
                                        ) : (
                                          t("SignIn")
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        // </GoogleReCaptchaProvider>
                      ) : showForgotPassword && !showNewPassword ? (
                        <>
                          <div className="col-12 forgot-modal-box">
                            <div className="col-12 mt-4 mb-4">
                              <p className="" onClick={handleBackToSignInClick}>
                                <IoIosArrowBack
                                  size={26}
                                  style={{
                                    color:
                                      theme === "dark" ? "#6c6c6c" : "inherit",
                                  }}
                                />{" "}
                                <span className="back-font">
                                  {t("backToSignIn")}{" "}
                                </span>
                              </p>
                            </div>
                            <div className="mb-4">
                              <h3 className="title-text mb-2">
                                {t("forgotPassword")}
                              </h3>
                              <p className="subtitle-text">
                                {t("enterYourEmail")}
                              </p>
                            </div>
                            <form
                              action="#!"
                              className="signup-form"
                              onSubmit={handlePasswordSubmit}
                            >
                              <div className="row gy-3 gy-md-4 overflow-hidden">
                                <div className="col-12 mb-2">
                                  <input
                                    placeholder={t("enterYourEmailaddress")}
                                    className="form-control"
                                    name="ForgotEmail"
                                    type="text"
                                    id="ForgotEmail"
                                    value={ForgotEmail}
                                    onChange={(e) =>
                                      setForgotEmail(e.target.value)
                                    }
                                  />
                                </div>
                                {emailError && (
                                  <div
                                    className="error-message"
                                    style={{ color: "red" }}
                                  >
                                    {emailError}
                                  </div>
                                )}
                                <div className="col-12">
                                  <div className="d-grid">
                                    <button
                                      className="btn bsb-btn-xl btn-primary lg-signin-btn"
                                      type="submit"
                                      disabled={!ForgotEmail.trim()}
                                    >
                                      {t("submit")}
                                    </button>
                                  </div>
                                </div>
                                {errorMessage && (
                                  <div
                                    className="error-message"
                                    style={{ color: "red" }}
                                  >
                                    {errorMessage}
                                  </div>
                                )}
                              </div>
                            </form>
                          </div>

                          {loader && <DivLoader />}
                        </>
                      ) : showNewPassword ? (
                        <>
                          <div className="col-12 forgot-modal-box newPassword-formst">
                            <div className="col-12 mt-4 mb-4">
                              <p className="" onClick={handleBackToSignInClick}>
                                <IoIosArrowBack
                                  size={26}
                                  style={{
                                    color:
                                      theme === "dark" ? "#6c6c6c" : "inherit",
                                  }}
                                />{" "}
                                <span className="back-font">
                                  {t("backToSignIn")}{" "}
                                </span>
                              </p>
                            </div>
                            <div className="mb-4">
                              <h3 className="title-text mb-4">
                                {t("pleaseEnterNewPassword")}
                              </h3>
                            </div>
                            <form
                              action="#!"
                              className="signup-form"
                              onSubmit={handleSaveSuccessfulSubmit}
                            >
                              <div className="row gy-3 gy-md-4 overflow-hidden">
                                <div className="col-12 mb-2">
                                  <span className="text-danger">*</span>{" "}
                                  <label htmlFor="email" className="form-label">
                                    {t("email")}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={email}
                                    placeholder="Enter your Email"
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                  {errors.email && (
                                    <div className="text-danger">
                                      {errors.email}
                                    </div>
                                  )}
                                </div>
                                <div className="col-12 mt-2 mb-2 position-relative">
                                  <span className="text-danger">*</span>{" "}
                                  <label
                                    htmlFor="oldPassword"
                                    className="form-label"
                                  >
                                    {t("password")}
                                  </label>
                                  <input
                                    type={oldPasswordType}
                                    className="form-control"
                                    name="oldPassword"
                                    id="oldPassword"
                                    value={oldPassword}
                                    onChange={(e) =>
                                      setOldPassword(e.target.value)
                                    }
                                  />
                                  <label
                                    className="eye-icon-position1"
                                    onClick={handleOldPasswordToggle}
                                  >
                                    {oldPasswordType === "text" ? (
                                      <FaEyeSlash size={22} />
                                    ) : (
                                      <FaEye size={22} />
                                    )}
                                  </label>
                                  {errors.oldPassword && (
                                    <div className="text-danger">
                                      {errors.oldPassword}
                                    </div>
                                  )}
                                </div>
                                <div className="col-12 mt-2 mb-2 position-relative">
                                  <span className="text-danger">*</span>{" "}
                                  <label
                                    htmlFor="newPassword"
                                    className="form-label"
                                  >
                                    {t("newPassword")}
                                  </label>
                                  <input
                                    type={newPasswordType}
                                    className="form-control"
                                    name="new_password"
                                    id="newPassword"
                                    value={newPassword}
                                    onChange={(e) =>
                                      setNewPassword(e.target.value)
                                    }
                                  />
                                  <label
                                    className="eye-icon-position1"
                                    onClick={handleNewPasswordToggle}
                                  >
                                    {newPasswordType === "text" ? (
                                      <FaEyeSlash size={22} />
                                    ) : (
                                      <FaEye size={22} />
                                    )}
                                  </label>
                                  {errors.newPassword && (
                                    <div className="text-danger">
                                      {errors.newPassword}
                                    </div>
                                  )}
                                </div>
                                <div className="col-12 mt-2 mb-2 position-relative">
                                  <span className="text-danger">*</span>{" "}
                                  <label
                                    htmlFor="confirmPassword"
                                    className="form-label"
                                  >
                                    {t("confirmNewPassword")}
                                  </label>
                                  <input
                                    type={confirmPasswordType}
                                    className="form-control"
                                    name="confirm_password"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) =>
                                      setConfirmPassword(e.target.value)
                                    }
                                  />
                                  <label
                                    className="eye-icon-position1"
                                    onClick={handleConfirmPasswordToggle}
                                  >
                                    {confirmPasswordType === "text" ? (
                                      <FaEyeSlash size={22} />
                                    ) : (
                                      <FaEye size={22} />
                                    )}
                                  </label>
                                  {errors.confirmPassword && (
                                    <div className="text-danger">
                                      {errors.confirmPassword}
                                    </div>
                                  )}
                                </div>
                                <div className="col-12">
                                  <div className="d-grid">
                                    <button
                                      className="btn bsb-btn-xl btn-primary lg-signin-btn"
                                      type="submit"
                                    >
                                      {t("save")}
                                    </button>
                                  </div>
                                </div>
                                {errorMessage && (
                                  <div
                                    className="error-message"
                                    style={{ color: "red" }}
                                  >
                                    {errorMessage}
                                  </div>
                                )}
                              </div>
                            </form>
                          </div>

                          {/* Save Confirmation Modal */}
                          <Modal
                            className="save-confirmation-modal"
                            show={showSaveConfirmation}
                            onHide={handleCloseSaveConfirmation}
                          >
                            <Modal.Header
                              closeButton
                              className="border-btm-0 pe-4 pt-3 pb-0"
                            >
                              {" "}
                            </Modal.Header>
                            <Modal.Body>
                              <div className="col-sm-12 text-center">
                                <img
                                  className="img-fluid gif-wid"
                                  src={`${process.env.PUBLIC_URL}/images/confirm-sucessfully.gif`}
                                  alt="Save Confirmation"
                                />
                              </div>
                              <div className="col-sm-12 text-center mb-5">
                                <h4 className="omnes-medium-font mb-0">
                                  {" "}
                                  {t("newPassword")}{" "}
                                </h4>
                                <h4 className="omnes-medium-font">
                                  {" "}
                                  {t("confirmedSuccessfully")}{" "}
                                </h4>
                                <p className="omnes-regular-font">
                                  {t("successfullyConfirmPassword")}
                                </p>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </>
                      ) : (
                        <div className="col-12 signup-modal-box">
                          <div className="mb-3">
                            <h3 className="title-text mb-2">{t("SignUp")}</h3>
                            <p className="subtitle-text mb-3">
                              {t("pleaseCreateYourAccount")}
                            </p>
                          </div>
                          {registerMsg && (
                            <div class="alertnew alertnew-success" >
                              <strong>Success!</strong> {t("RegisterUsermsg")}
                            </div>
                          )}

                          <form
                            action="#!"
                            onSubmit={handleSubmit}
                            className="signup-form"
                            autocomplete="off"
                          >
                            <div className="row ">
                              <div className="col-12 col-lg-6 mt-0  mb-2 ">
                                <div
                                  className={`input-wrapper ${isCtrlEmpty.signupusername &&
                                    !isCtrlFocused.signupusername
                                    ? "show-asterisk"
                                    : ""
                                    }`}
                                  required
                                >
                                  <input
                                    placeholder={t("User Name")}
                                    type="text"
                                    className={`form-control ${errors.signupusername ? "is-invalid" : ""
                                      }`}
                                    value={formData.signupusername}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    name="signupusername"
                                    id="signupusername"
                                    maxLength="50"
                                    autocomplete="off"
                                  />
                                </div>
                                {errors.signupusername && (
                                  <div className="error-message">
                                    {errors.signupusername}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6 mb-2 mt-0 position-relative">
                                <div
                                  className={`input-wrapper ${isCtrlEmpty.signuppassword &&
                                    !isCtrlFocused.signuppassword
                                    ? "show-asterisk"
                                    : ""
                                    }`}
                                  required
                                >
                                  <input
                                    placeholder={t("password")}
                                    type={type}
                                    id="signuppassword"
                                    name="signuppassword"
                                    className={`form-control ${errors.signuppassword ? "input-error" : ""
                                      }`}
                                    value={formData.signuppassword}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    maxLength="255"
                                    autocomplete="off"
                                  />
                                </div>

                                <label
                                  className="eye-icon-position1"
                                  onClick={handleToggle}
                                >
                                  {type === "text" ? (
                                    <FaEyeSlash size={22} />
                                  ) : (
                                    <FaEye size={22} />
                                  )}
                                </label>
                                {errors.signuppassword && (
                                  <div className="error-message">
                                    {errors.signuppassword}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6 mb-2 mt-0">
                                <div
                                  className={`input-wrapper ${isCtrlEmpty.firstName &&
                                    !isCtrlFocused.firstName
                                    ? "show-asterisk"
                                    : ""
                                    }`}
                                  required
                                >
                                  <input
                                    type="text"
                                    placeholder={t("firstName")}
                                    id="firstName"
                                    name="firstName"
                                    className={`form-control ${errors.firstName ? "is-invalid" : ""
                                      }`}
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    maxLength={100}
                                  />
                                </div>
                                {errors.firstName && (
                                  <div className="error-message">
                                    {errors.firstName}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6 mb-2 mt-0">
                                <div
                                  className={`input-wrapper ${isCtrlEmpty.lastName &&
                                    !isCtrlFocused.lastName
                                    ? "show-asterisk"
                                    : ""
                                    }`}
                                  required
                                >
                                  <input
                                    placeholder={t("lastName")}
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    className={`form-control ${errors.lastName ? "is-invalid" : ""
                                      }`}
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    maxLength={100}
                                  />
                                </div>
                                {errors.lastName && (
                                  <div className="error-message">
                                    {errors.lastName}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6 mb-2 mt-0">

                                <div
                                  className={`input-wrapper ${isCtrlEmpty.email && !isCtrlFocused.email
                                    ? "show-asterisk"
                                    : ""
                                    }`}
                                  required
                                >
                                  <input
                                    placeholder={t("email")}
                                    type="text"
                                    id="email"
                                    name="email"
                                    className={`form-control ${errors.email ? "is-invalid" : ""
                                      }`}
                                    value={formData.email}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    maxLength={100}
                                  />
                                </div>
                                {errors.email && (
                                  <div className="error-message">
                                    {errors.email}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6 mb-2 mt-0">
                                <div
                                  className={`input-wrapper ${isCtrlEmpty.jobTitle &&
                                    !isCtrlFocused.jobTitle
                                    ? "show-asterisk"
                                    : ""
                                    }`}
                                  required
                                >
                                  <input
                                    placeholder={t("jobTitle")}
                                    type="text"
                                    id="jobTitle"
                                    name="jobTitle"
                                    className={`form-control ${errors.jobTitle ? "is-invalid" : ""
                                      }`}
                                    value={formData.jobTitle}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    maxLength={50}
                                  />
                                </div>
                                {errors.jobTitle && (
                                  <div className="error-message">
                                    {errors.jobTitle}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6 mb-2 mt-0">
                                <div
                                  className={`input-wrapper ${isCtrlEmpty.organization &&
                                    !isCtrlFocused.organization
                                    ? "show-asterisk"
                                    : ""
                                    }`}
                                  required
                                >
                                  <input
                                    placeholder={t("organization")}
                                    type="text"
                                    id="organization"
                                    name="organization"
                                    className={`form-control ${errors.organization ? "is-invalid" : ""
                                      }`}
                                    value={formData.organization}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    maxLength={100}
                                  />
                                </div>
                                {errors.organization && (
                                  <div className="error-message">
                                    {errors.organization}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6 mb-2 mt-0">

                                <input
                                  placeholder={t("address")}
                                  type="text"
                                  id="address"
                                  name="address"
                                  className={`form-control ${errors.address ? "is-invalid" : ""
                                    }`}
                                  value={formData.address}
                                  onChange={handleChange}
                                  maxLength={500}
                                />
                              </div>
                              {errors.address && (
                                <div className="error-message">
                                  {errors.address}
                                </div>
                              )}
                              <div className="col-12 col-lg-6 mb-2 mt-0">
                                {/* <label htmlFor="city">{t("city")}</label> */}
                                <input
                                  placeholder={t("city")}
                                  type="text"
                                  id="city"
                                  name="city"
                                  className={`form-control ${errors.city ? "is-invalid" : ""
                                    }`}
                                  value={formData.city}
                                  onChange={handleChange}
                                  maxLength={50}
                                />
                                {errors.city && (
                                  <div className="error-message">
                                    {errors.city}
                                  </div>
                                )}
                              </div>

                              <div className="col-12 col-lg-6 mb-2 mt-0">

                                <input
                                  placeholder={t("country")}
                                  type="text"
                                  className={`form-control ${errors.state ? "is-invalid" : ""
                                    }`}
                                  id="state"
                                  name="state"
                                  value={formData.state}
                                  onChange={handleChange}
                                  maxLength={50}
                                />
                                {errors.state && (
                                  <div className="error-message">
                                    {errors.state}
                                  </div>
                                )}
                              </div>

                              <div className="col-12 col-lg-6 mb-2 mt-0">
                                <input
                                  placeholder={t("postalCode")}
                                  type="text"
                                  name="postalCode"
                                  value={formData.postalCode || ""}
                                  onChange={handleChange}
                                  id="postalCode"
                                  className={`form-control ${errors.postalCode ? "is-invalid" : ""
                                    }`}
                                  maxLength={10}
                                />
                                {errors.postalCode && (
                                  <div className="error-message">
                                    {errors.postalCode}
                                  </div>
                                )}
                              </div>

                              <div className="col-12 col-lg-6 mb-2 mt-0">
                                <input
                                  placeholder={t("phone")}
                                  type="text"
                                  className={`form-control ${errors.phone ? "is-invalid" : ""
                                    }`}
                                  id="phone"
                                  name="phone"
                                  value={formData.phone}
                                  onChange={handleChange}
                                  maxLength={20}
                                />
                                {errors.phone && (
                                  <div className="error-message">
                                    {errors.phone}
                                  </div>
                                )}
                              </div>
                              {loader ? (
                                <DivLoader />
                              ) : (
                                Requestmsg && (
                                  <span className="text-success">
                                    {Requestmsg}
                                  </span>
                                )
                              )}
                              <div className="col-12 col-lg-6">
                                <div className="d-grid">
                                  <button
                                    className="btn bsb-btn-xl btn-primary lg-signin-btn"
                                    type="submit"
                                    disabled={loader}
                                  >
                                    {loader ? (
                                      <>
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                        />
                                      </>
                                    ) : (
                                      t("SignUp")
                                    )}
                                  </button>
                                </div>
                              </div>
                              {errorMessage && (
                                <div
                                  className="error-message"
                                  style={{ color: "red" }}
                                >
                                  {errorMessage}
                                </div>
                              )}
                            </div>
                          </form>

                          <div className="col-12">
                            <p
                              className="position-btm-20 text-left omnes-regular-font"
                              style={{
                                color: theme === "dark" ? "#fff" : "inherit",
                                marginTop: "20px",
                                bottom: "-25px",
                              }}
                            >
                              {t("Already have an account?")}
                              <button
                                className="link-secondary-forgot text-decoration-none nobuttonStyle"
                                onClick={handlesigninClick}
                              >
                                {" "}
                                {t("SignIn")}
                              </button>
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {!showForgotPassword &&
                      !showSignUp &&
                      activeTab !== "externalUserDB" ? (
                      <div className="row">
                        <div className="col-12 separator-land mt-2 mb-2">
                          <div class="line-land"></div>
                          <span class="text-land pe-2 ps-2">{t("Or")}</span>
                          <div class="line-land"></div>
                        </div>
                        <div className="col-12">
                          <p className="director-login-text" onClick={handleLogin}>{t("Sign in with")}<span> {t("activedirectory")} </span></p>
                          <p
                            className="position-btm-20 text-center centerText omnes-regular-font"
                            style={{
                              color: theme === "dark" ? "#fff" : "inherit",
                            }}
                          >
                            {t("dontAccount")}
                            <button
                              className="link-secondary-forgot text-decoration-none nobuttonStyle"
                              onClick={handleSignUpClick}
                            >
                              {" "}
                              {t("SignUp")}
                            </button>
                          </p>
                        </div>
                      </div>
                    ) : null}
                    {!showForgotPassword &&
                      !showSignUp &&
                      activeTab === "externalUserDB" &&
                      !showNewPassword ? (
                      <div className="row">
                        <div className="col-12">
                          <p
                            className="position-btm-20 text-center omnes-regular-font"
                            style={{
                              color: theme === "dark" ? "#fff" : "inherit",
                            }}
                          >
                            <button
                              className="link-secondary-forgot text-decoration-none nobuttonStyle"
                              onClick={handleChangePasswordClick}
                            >
                              {" "}
                              {t("changePassword")}
                            </button>
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default SignInModal;
